import React, { useEffect, useRef, useState } from "react";
import Quill from "quill";
import swal from "sweetalert";
import { getToken } from "../utils/auth";
import "quill/dist/quill.snow.css";
import "./StudyMaterialForm.css";

// Ensure there is a fallback if the env variable is missing
const API_URL = process.env.REACT_APP_API_BASE_URL;

const StudyMaterialForm = () => {
  const [course, setCourse] = useState("");
  const [loading, setLoading] = useState(false);

  const editorRef = useRef(null);
  const quillRef = useRef(null);

  useEffect(() => {
    if (editorRef.current && !quillRef.current) {
      quillRef.current = new Quill(editorRef.current, {
        theme: "snow",
        placeholder: "Enter study content...",
        modules: {
          toolbar: [
            [{ header: [1, 2, false] }],
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link"],
            ["clean"]
          ]
        }
      });
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const content = quillRef.current.root.innerHTML;

    if (!course || content === "<p><br></p>") {
      // Use swal for validation warning
      swal("Oops!", "All fields are required!", "warning");
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(`${API_URL}/api/study-material/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`
        },
        body: JSON.stringify({
          course,
          content,
        }),
      });

      if (!response.ok) {
        throw new Error(`Server responded with ${response.status}`);
      }

      // Success Message
      swal({
        title: "Success!",
        text: "Study material has been added.",
        icon: "success",
        button: "Great!",
      });

      setCourse("");
      quillRef.current.root.innerHTML = "";

    } catch (err) {
      console.error("Submission Error:", err);
      // Error Message
      swal("Error!", "Something went wrong while adding the material.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="study-container">
      <h2>Add Study Material</h2>

      <form onSubmit={handleSubmit} className="study-form">
        <input
          type="text"
          placeholder="Enter Course Name"
          value={course}
          onChange={(e) => setCourse(e.target.value)}
          className="input"
        />

        <div className="editor-wrapper">
          <div ref={editorRef} className="editor"></div>
        </div>

        <button type="submit" disabled={loading} className="submit-btn">
          {loading ? "Adding..." : "Add Material"}
        </button>
      </form>
    </div>
  );
};

export default StudyMaterialForm;